import { render, staticRenderFns } from "./plant.vue?vue&type=template&id=4e4e7a36&scoped=true"
import script from "./plant.vue?vue&type=script&lang=js"
export * from "./plant.vue?vue&type=script&lang=js"
import style0 from "./TreatmentStepTwoForms.styles.scss?vue&type=style&index=0&id=4e4e7a36&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e7a36",
  null
  
)

export default component.exports